var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ElementPicture',{class:[
    _vm.$style.image,
    ( _obj = {}, _obj[_vm.$style.isCircle] = _vm.isCircle, _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.isBadge] = _vm.isBadge, _obj$1 )
  ],attrs:{"src":_vm.src,"alt":_vm.alt,"is-avatar":"","aspect-ratio":1}})}
var staticRenderFns = []

export { render, staticRenderFns }